module.exports = __webpack_public_path__ + "media/images/lp/1/plight3-pc-38027de802ef9b8bdea757a2b13fe612.png";